module.exports = __webpack_public_path__ + "img/bg-code.37b5a1e7.jpg";